import React from 'react';

import ServiceOrderProvider from './index';

export const withServiceOrderContext = WrappedComponent => props => <ServiceOrderProvider><WrappedComponent {...props} /></ServiceOrderProvider>